module.exports = __webpack_public_path__ + "img/QA_pin05.bd5c4ffd.svg";